// extracted by mini-css-extract-plugin
export default {"tagline":"CoreValues_tagline__fkjnB"};